import React from 'react'
import './footer.scss'
import instagramlogo from "../../../images/insta-logo.svg";
import twitterlogo from "../../../images/twitter-logo.svg";
import { OutboundLink } from 'gatsby-plugin-google-analytics'

const Footer = ({ }) => (
  <div className="footer-container">
  <div className="footer-content-container">
  <div className="container">
  <div className="row">
  <div className="col-6">
  <span className="site-attribution">
  © 2019 Curveball.tv
  </span>
  </div>
  <div className="col-6 right">
  <div className="social-link-wrapper">
  <OutboundLink className="btn social-link" href="https://www.twitter.com/curveballtv" aria-label="Curveball on Twitter" target="__blank">
  <img alt="Twitter Logo" src={twitterlogo} />
  </OutboundLink>
  <OutboundLink className="btn social-link" href="https://www.instagram.com/curveballsports" aria-label="Curveball Sports on Instagram" target="__blank">
  <img alt="Instagram Logo" src={instagramlogo} />
  <span>Sports</span>
  </OutboundLink>
  <OutboundLink className="btn social-link" href="https://www.instagram.com/curveballgamers" aria-label="Curveball Gaming on Instagram" target="__blank">
  <img alt="Instagram Logo" src={instagramlogo} />
  <span>Gaming</span>
  </OutboundLink>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  )

export default Footer



// WEBPACK FOOTER //
// ./src/components/global/footer/footer.js